import { render, staticRenderFns } from "./mo-input-wrapper.html?vue&type=template&id=438a4b70&external"
import script from "./mo-input-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-input-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports